declare global {
  interface Window {
    clarity?: ClarityFn;
  }
}

type ClarityFn = {
  (...args: unknown[]): void;
  q?: unknown[];
};

/** Projeto Web no Microsoft Clarity (Link Park). */
export const CLARITY_PROJECT_ID = 'yg96phky7m';

export function getClarityProjectId(value = import.meta.env.VITE_CLARITY_PROJECT_ID): string {
  const trimmed = value?.trim() ?? '';
  return trimmed || CLARITY_PROJECT_ID;
}

export function isClarityLocalHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function isClarityEnabled(hostname?: string): boolean {
  if (!getClarityProjectId()) return false;
  if (hostname !== undefined) return !isClarityLocalHost(hostname);
  if (typeof window === 'undefined') return true;
  return !isClarityLocalHost(window.location.hostname);
}

let started = false;

export function initClarity(): void {
  if (started || typeof window === 'undefined') return;
  if (!isClarityEnabled(window.location.hostname)) return;

  const projectId = getClarityProjectId();
  if (!projectId) return;

  started = true;

  const clarity: ClarityFn = function (...args: unknown[]) {
    (clarity.q = clarity.q ?? []).push(args);
  };
  window.clarity = window.clarity ?? clarity;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  document.head.appendChild(script);
}

export function identifyClarityUser(
  userId: string,
  tags: Record<string, string | undefined> = {},
): void {
  if (!started || typeof window === 'undefined' || !window.clarity) return;
  window.clarity('identify', userId);
  for (const [key, value] of Object.entries(tags)) {
    if (value) window.clarity('set', key, value);
  }
}

export function clarityRoleTag(user: {
  isGlobalAdmin?: boolean;
  isCondominiumManager?: boolean;
}): string {
  if (user.isGlobalAdmin) return 'global-admin';
  if (user.isCondominiumManager) return 'manager';
  return 'resident';
}
